import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { NotificationService } from '../services/notification.service';

type ApiResponse<T = unknown> = {
  message?: string;
  data?: T;
  handlecode?: string | number;
  permissions?: string[] | null;
  notifications?: string[] | null;
};

@Injectable()
export class NotificationInterceptor implements HttpInterceptor {
  constructor(private notificationServer: NotificationService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const expectsJson = req.responseType === 'json' || req.responseType === undefined;

    return next.handle(req).pipe(
      tap(event => {
        if (!expectsJson) return;
        if (event instanceof HttpResponse) {
          const body = event.body as ApiResponse | null;
          if (body && typeof body === 'object' && 'notifications' in body) {
            if (body.notifications) {
              this.notificationServer.setNotification(body.notifications);
            }
          }
        }
      })
    );
  }
}